'use strict';

module.exports = function ($) {
	return {
		init: init
	};

  function init() {
    cancelAnimateOnScroll();
		initToggleClass();
		initBodyClass();
		initAddClass();
    initToggleTarget();
    initCloseOthers();
		initClickBlock();
		initScrollTo();
		initTabs();
    initGtagEvents();
    outputRangeValue();
	}

  function cancelAnimateOnScroll() {
		$(window).on('mousewheel', function(){
		  $('html,body').stop();
		});
  }

	function initToggleClass() {

		/*
			Set any class on CLICK
			========================================================
			Allows us to toggle a class on any element via click,
			as defined by data attribute attached to the element
		*/

		var toggleElement = $('[data-toggle-class]');

		toggleElement.on('click', function (event) {
			var $this = $(this);
			var activeClass = $this.data('toggle-class');

			// untoggle any siblings with the active class
			$this.siblings().removeClass(activeClass);

			// toggle the active class
			$this.toggleClass(activeClass).focus();

			// if it's an anchor prevent default
			if ($this.attr('href')) {
				event.preventDefault();
			}


			$this.children('[data-toggle-animate]').stop().slideToggle(300);
			$this.siblings().children('[data-toggle-animate]').stop().slideUp(300);

		});

	}

	function initBodyClass() {

		/*
			Set any class on CLICK
			========================================================
			Allows us to toggle a class on any element via click,
			as defined by data attribute attached to the element
		*/

		var toggleElement = $('[data-toggle-body]');

		toggleElement.on('click', function (event) {
			var $this = $(this);
			var activeClass = $this.data('toggle-body');

			$this.focus();

			// toggle the active class
			$('body').toggleClass(activeClass);

			// if it's an anchor prevent default
			if ($this.attr('href')) {
				event.preventDefault();
			}

		});

	}


	function initAddClass() {

		/*
			Set any class on CLICK
			========================================================
			Allows us to add a class on any element via click,
			as defined by data attribute attached to the element
		*/

		var toggleElement = $('[data-add-class]');

		toggleElement.on('click', function (event) {
			var $this = $(this);
			var activeClass = $this.data('add-class');

			// untoggle any siblings with the active class
			$this.siblings().removeClass(activeClass);

			// toggle the active class
			$this.addClass(activeClass);

			// if it's an anchor prevent default
			if ($this.attr('href')) {
				event.preventDefault();
			}
		});

	}


	function initToggleTarget() {

		/*
			Toggle a target via data attribute
			========================================================
			Toggle .active class of another element on click
		*/

    $(document).on('click', '[data-toggle-target]', function (event) {
			var $this = $(this);
			var toggleTargetName = $this.data('toggle-target');
      var toggleTarget = $('[data-toggle=' + toggleTargetName + ']');
      var toggleButtons = $('[data-toggle-target=' + toggleTargetName + ']');

      if (toggleTargetName === 'toolkit') {
				$('body').toggleClass('freeze-body toolkit-visible');
      }

			// toggle the target element
			if (toggleTarget.hasClass('active')) {
				toggleTarget
					.stop(true)
					.removeClass('active')
          .addClass('inactive');
        toggleButtons
            .removeClass('active')
			} else {
				toggleTarget
					.stop(true)
					.addClass('active')
          .removeClass('inactive');
          toggleButtons
            .addClass('active')
			}



			// if target has data-toggle-animate attribute
			// show it using slideToggle animation
			if ( toggleTarget[0].hasAttribute('data-toggle-animate') ) {
				toggleTarget.stop().slideToggle(400);
			}

			if ( toggleTarget[0].hasAttribute('data-toggle-animate-slow') ) {
				toggleTarget.stop().slideToggle(1200);
			}

      // toggle siblings if data-close-siblings
      if ( $this[0].hasAttribute('data-close-siblings') ) {
				var $siblings = $this.parents('[data-close-siblings-parent]').siblings();

        $siblings
          .find('[data-toggle]')
          .slideUp(300);

        $siblings
          .find('[data-toggle-target]')
          .removeClass('active');
			}

			// if it's an anchor prevent default
			if ( $this.attr('href') ) {
				event.preventDefault();
				event.stopPropagation();
			}
		});
	}

  function initCloseOthers() {
		var closeOthers = $('[data-close-others]');

		closeOthers.on('click', function() {
			var $this = $(this);
			var closeTargetName = $this.data('close-others');
			var closeTarget = $('[data-toggle=' + closeTargetName + ']');

			closeTarget
				.removeClass('active')
        .addClass('inactive');

		});
	}

	function initClickBlock() {

		/*
			Clickable block
			========================================================
			Make an entire block element clickable by finding
			an [href] within that block, and passing to
			window.location.
		*/

		var clickBlock = $('.clickBlock');

		clickBlock.on('click', function () {
			var $this = $(this);

			var thisURL = $this.find('a').attr('href');
			// ensure we have an href to pass in..
			if (typeof thisURL !== 'undefined') {
				// then redirect page with js
				window.location = thisURL;
			}
			return false;
		});
	}


	function initScrollTo() {

		/*
			Scroll To
			========================================================
			Use default anchor name behaviour but augment it with a
			bit of JS to scroll the page
		*/

		$(document).on('click', '[data-scroll-to], a[href^="#"]', function(event) {
			if (event) { event.preventDefault(); }
			var $this = $(this);
			var scrollTarget;

			var anchorID 			= $this.attr('href');
			var anchorName 		= anchorID.replace('#','');

			scrollTarget 	= $('a[name*="' + anchorName + '"]');

			if (!scrollTarget.length) {
				scrollTarget 	= $('#' + anchorName);
			}

      if (scrollTarget.length) {
        $('html,body').animate({
          // animate to target
            scrollTop: scrollTarget.offset().top - 120,
            easing: 'easeInOutQuad'
        }, 1250);

        history.replaceState({}, '', anchorID);
      }

		});
	}


	function initTabs() {

		/*
			Tabs
			========================================================
			Allows us to move between sets of tabbed page content
			Finds the data-tab-target attribute, which is used to locate
			the parent <div> of tabbed content.
			Then use the .index position of clicked tab to find the
			tab content child .eq to that index.
		*/

		var tab = $('[data-tab-target] a');

		// swap tabs
		tab.on('click', function (event) {
			event.preventDefault();
			var $this = $(this);

			var thisTab = $this.parents('li');
			var thisIndex = thisTab.index();
			var targetName = thisTab.parent().data('tab-target');
			var targetTabs = $('[data-tabs=' + targetName + ']');
			var targetContent = targetTabs.children().eq(thisIndex);

			// console.log(targetName);

			// adjust the tab itself
			thisTab.siblings().removeClass('active');
			thisTab.addClass('active');

			// adjust the content
			targetContent.siblings().stop().fadeOut(250);
			targetContent.stop().delay(300).fadeIn(500);
			targetTabs.attr('data-tab-index', thisIndex);

		});

	}


	// Events for google analytics
	function initGtagEvents() {
		var gtagElement = $('[data-gtag-event]');

		gtagElement.on('click', function () {
			var $this = $(this);
			var $params = {};
			var gtagEventName = $this.data('gtag-event');
			var gtagEventVariable = $this.data('gtag-event-variable');
			var gtagEventVariableData = $this.data('gtag-event-variable-data');

			// Fire event only once
			if (!$this.hasClass('gtag-event-fired')) {
				$this.addClass('gtag-event-fired');

				$params.event = gtagEventName;
				if (gtagEventVariableData && gtagEventVariable) $params[gtagEventVariable] = gtagEventVariableData;

				window[gtm4wp_datalayer_name].push($params);
			}
		});
  }

  function outputRangeValue() {
    var $range = $('.range-input input[type="range"');
    var $displayElement = $range.parents('.range-input').find('.range-input__counter span');

    $range.on('input', function(event) {
      $displayElement.html(event.target.value);
    });
  }

};
